import { put, call, takeLatest, select } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';

import fbEmmiter from '../../../events/facebookEvents';
import { formatError } from '../../../libs';
import contactAPI from '../../api/contact';
import { Types, Creators as ContactCreators } from '../../reducers/contact';
import getState from '../../utils/getState';

function* sendNewsletter({ data }) {
  try {
    const {
      app: { config = {} },
    } = yield select(getState);

    const { siteId } = config;

    const result = yield call(
      contactAPI.sendNewsletter,
      {
        event_id: config.getIn(['notifyMe', 'newsletter']),
        event_name: 'CR_HOME',
        m: config.getIn(['seller']),
        ...data,
      },
      siteId
    );

    if (!isEmpty(result)) {
      throw new Error('Ocorreu algum erro, tente novamente.');
    }

    yield put(
      ContactCreators.sendNewsletterSuccess({
        newsletter: { result: 'E-mail cadastrado com sucesso!' },
        error: {},
      })
    );

    fbEmmiter('Lead');
  } catch (error) {
    yield put(ContactCreators.sendNewsletterError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SEND_NEWSLETTER_REQUEST, sendNewsletter);
}
